<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  provide() {
    // 在祖先组件中通过 provide 提供变量
    return {
      reload: this.reload //  声明一个变量
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  mounted() {
    // 刷新时将信息存到session
    window.addEventListener('unload', this.saveState)
  },
  methods: {
    saveState() {
      sessionStorage.setItem(
        'userState',
        JSON.stringify(this.$store.state.user)
      )
    },
    reload() {
      // 通过 this.isRouterAlive 控制 router-view 达到刷新效果
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
html,
body,
#app {
  height: 100%;
}

body {
  display: block;
  margin: 0;
}
</style>
